export const rshRules = {
    if: [
        {
            '==': [
                {
                    var: 'field_rn1521689671200',
                },
                'campaign',
            ],
        },
        false,
        {
            and: [
                {
                    '!': [
                        {
                            or: [
                                {
                                    in: [
                                        'waiver_on_non_cimb_account',
                                        {
                                            var: 'field_rn1520139895588',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'approval_for_ipp_24_months',
                                        {
                                            var: 'field_rn1520139895588',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'approval_for_ipp_36_months',
                                        {
                                            var: 'field_rn1520139895588',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'mthly_vol_rm30k',
                                        {
                                            var: 'field_rn1520139895588',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_deposit_edc',
                                        {
                                            var: 'field_rn1520139943268',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_rental_edc',
                                        {
                                            var: 'field_rn1520139943268',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'pre_auth_offline_non_approved_segment',
                                        {
                                            var: 'field_rn1520139943268',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'manual_key_in',
                                        {
                                            var: 'field_rn1520139943268',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'refund',
                                        {
                                            var: 'field_rn1520139943267',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_deposit_mpos',
                                        {
                                            var: 'field_rn1520139992476',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_rental_mpos',
                                        {
                                            var: 'field_rn1520139992476',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_reduced_card_reader_fee_mpos',
                                        {
                                            var: 'field_rn1520139992476',
                                        },
                                    ],
                                },
                                {
                                    in: [
                                        'waiver_on_standard_mpos_transaction_capping',
                                        {
                                            var: 'field_rn1520139992476',
                                        },
                                    ],
                                },
                                {
                                    and: [
                                        {
                                            '>': [
                                                {
                                                    '+': { var: ['field_rn1522049175999', '0'] },
                                                },
                                                0,
                                            ],
                                        },
                                        {
                                            '==': [
                                                'card_reader_fee',
                                                {
                                                    var: ['field_rn1521017755844', 'false'],
                                                },
                                            ],
                                        },
                                        {
                                            or: [
                                                {
                                                    '<': [
                                                        {
                                                            var: ['field_rn1521017882606', '450'],
                                                        },
                                                        '450',
                                                    ],
                                                },
                                                {
                                                    '<': [
                                                        {
                                                            var: ['field_rn1521017864764', '550'],
                                                        },
                                                        '550',
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138350872', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138390941', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138401274', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138434889', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    if: [
                        {
                            in: [
                                {
                                    var: 'field_rn1520138475799',
                                },
                                ['', null],
                            ],
                        },
                        true,
                        {
                            '>=': [
                                {
                                    var: ['field_rn1520138475799', 1.5],
                                },
                                '1.5',
                            ],
                        },
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_edc_off_us_mydebit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_edc_on_us_mydebit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138495393', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138497404', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138499606', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138633648', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138638992', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138640745', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642609', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138633649', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138638993', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138640746', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642610', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138633650', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138638995', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138640748', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642612', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138633629', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138638983', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138640736', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642600', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138633529', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138638883', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138640636', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642500', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138642598', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138831968', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833918', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138835472', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138837393', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138830208', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138351872', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138398941', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138408274', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138433889', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    if: [
                        {
                            in: [
                                {
                                    var: 'field_rn1520138474799',
                                },
                                ['', null],
                            ],
                        },
                        true,
                        {
                            '>=': [
                                {
                                    var: ['field_rn1520138474799', 1.5],
                                },
                                '1.5',
                            ],
                        },
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_off_us_mydebit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_on_us_mydebit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138494393', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138496404', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138498606', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833648', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138838992', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138840745', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138842609', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833649', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138838993', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138840746', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138842610', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833650', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138838995', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138840748', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138842612', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833629', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138838983', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138840736', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138842600', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_rps_off_us_credit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_rps_on_us_credit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_rps_off_us_debit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_rps_on_us_debit', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_contactless_plug_pay_rps_intl', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138831967', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833917', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138835471', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138837392', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138830207', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138813648', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138818992', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138810745', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138812609', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138813745', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138818993', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138810746', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138812610', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138813458', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138818995', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138810748', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138812612', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138813629', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138818983', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138810736', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138812600', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138831962', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138833911', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138835478', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138837399', 1.5],
                        },
                        '1.5',
                    ],
                },
                {
                    '>=': [
                        {
                            var: ['field_rn1520138830204', 1.5],
                        },
                        '1.5',
                    ],
                },
            ],
        },
    ],
};
